import classes from "./index.module.scss";

export default function Main({ children }) {
  return <main className={classes.main}>{children}</main>;
}
